import React from "react"

const FormRow = ({ form, urlHost }) => {
  return <>
    <tr key={form.id} className='border-b border-gray-400 leading-8'>
      <td className="px-4 py-2">{form.record_type}</td>
      <td>{`${urlHost}/api/mobile_records/geo_json?record_type=${form.record_type}`}</td>
    </tr>
  </>
}

export default FormRow
